var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _vm.popupGbn == 0
        ? _c("div", { staticClass: "all-menu" }, [
            _c("div", { staticClass: "header" }, [
              _c(
                "div",
                {
                  staticClass: "close",
                  on: {
                    click: function($event) {
                      _vm.menuOpen = false
                    }
                  }
                },
                [_c("i", { staticClass: "icon icon-m-close" })]
              ),
              _c(
                "div",
                {
                  staticClass: "nation",
                  on: {
                    click: function() {
                      ;(_vm.openedSetSiteInfoData = true), (_vm.popupGbn = 3)
                    }
                  }
                },
                [
                  _c("i", { class: "icon icon-nation-" + _vm.natCode }),
                  _vm.siteCode == _vm.$config.SITECODE_OGHCM
                    ? _c("span", { staticClass: "name" }, [
                        _vm._v(_vm._s(_vm.$t("ogvtn_국가명")))
                      ])
                    : _c("span", { staticClass: "name" }, [
                        _vm._v(_vm._s(_vm.$t(_vm.siteCode + "_국가명")))
                      ])
                ]
              ),
              _c("div", { staticClass: "user-info" }, [
                !_vm.isLogin
                  ? _c(
                      "div",
                      { staticClass: "branch wflex" },
                      [
                        _vm.siteCode == _vm.$config.SITECODE_OGHCM
                          ? [
                              _vm.isLogin
                                ? [
                                    _vm.operGroupCd == "VN1"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(_vm.siteCode + "_지점명칭")
                                            )
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(_vm.$t("oghni_지점명칭"))
                                          )
                                        ]
                                  ]
                                : [
                                    _vm._v(
                                      _vm._s(
                                        /*국민은행 베트남 */ _vm.$t(
                                          "MPAY-04-01-09-18"
                                        )
                                      )
                                    )
                                  ]
                            ]
                          : [_vm._v(_vm._s(_vm.$t(_vm.siteCode + "_지점명칭")))]
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.isLogin
                  ? _c(
                      "div",
                      { staticClass: "user" },
                      [
                        _vm.sessionInfo.userInfo.ppsnCoprDstcd == "1"
                          ? [_vm._v(_vm._s(_vm.sessionInfo.userInfo.userName))]
                          : [
                              _vm._v(
                                _vm._s(
                                  _vm.sessionInfo.userInfo.sbidDstcd == "1"
                                    ? _vm.sessionInfo.userInfo.userName
                                    : _vm.sessionInfo.userInfo.subUserName
                                )
                              )
                            ]
                      ],
                      2
                    )
                  : _vm._e(),
                !_vm.isLogin
                  ? _c(
                      "button",
                      {
                        staticClass: "btn-login",
                        on: {
                          click: function() {
                            this$1.$router.push({ name: "login" }),
                              (_vm.menuOpen = false)
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(/*로그인*/ _vm.$t("MLGI-01-01-01-07")) +
                            " "
                        )
                      ]
                    )
                  : _vm._e(),
                !_vm.isLogin && _vm.siteCode == _vm.$config.SITECODE_OGHCM
                  ? _c(
                      "button",
                      {
                        staticClass: "btn-login",
                        on: {
                          click: function() {
                            this$1.$router.push({
                              name: "joinServiceEnterVtn"
                            }),
                              (_vm.menuOpen = false)
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(/* 회원가입 */ _vm.$t("EKYC-14-01")) +
                            " "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.isLogin
                  ? _c("i", {
                      staticClass: "icon",
                      class:
                        "" +
                        (_vm.isCustNtc
                          ? "icon-nav-alarm-new"
                          : "icon-nav-alarm"),
                      on: {
                        click: function($event) {
                          return _vm.goToNoticeService()
                        }
                      }
                    })
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "news",
                    on: {
                      click: function($event) {
                        return _vm.goToDetail()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "date" }, [
                      _vm._v(
                        _vm._s(_vm.$getGlobalDateYmd(_vm.getLatestNews.regiYMS))
                      )
                    ]),
                    _vm.lang == "KOR"
                      ? _c("span", {
                          staticClass: "title",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$htmlDecode(_vm.getLatestNews.hanglTitlCtnt)
                            )
                          }
                        })
                      : _vm.lang == "ENG"
                      ? _c("span", {
                          staticClass: "title",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$htmlDecode(_vm.getLatestNews.engTitlCtnt)
                            )
                          }
                        })
                      : _c("span", {
                          staticClass: "title",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$htmlDecode(_vm.getLatestNews.lcalTitlCtnt)
                            )
                          }
                        })
                  ]
                )
              ]),
              _c("div", { staticClass: "top-nav" }, [
                _c(
                  "div",
                  { staticClass: "home", on: { click: _vm.goToMain } },
                  [_c("i", { staticClass: "icon icon-s-home" }), _vm._v("HOME")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "auth",
                    on: {
                      click: function($event) {
                        return _vm.openPopup(1)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "icon icon-auth" }),
                    _vm._v(
                      " " + _vm._s(/*인증센터*/ _vm.$t("MMENU-0064")) + " "
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.reportAccount,
                        expression: "reportAccount"
                      }
                    ],
                    staticClass: "return",
                    on: {
                      click: function($event) {
                        return _vm.openPopup(2)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "icon icon-return" }),
                    _vm._v(
                      " " + _vm._s(/*사고신고*/ _vm.$t("MMENU-0052")) + " "
                    )
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "side-nav" }, [
                _c(
                  "div",
                  { staticClass: "tabs", attrs: { id: "tabs" } },
                  [
                    _vm._l(
                      _vm.allmenu ? _vm.getMenuByLogin : _vm.getMenuByLogout,
                      function(tab, index) {
                        return [
                          tab.name != "reportAccountMmr" &&
                          tab.name != "certificationCenter"
                            ? [
                                tab.isShow
                                  ? _c(
                                      "button",
                                      {
                                        key: index,
                                        staticClass:
                                          "tab-button tab-button--type1",
                                        class: {
                                          active: _vm.currentTab === index
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.currentTab = index
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "btn-text" },
                                          [_vm._v(_vm._s(_vm.$t(tab.title)))]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e()
                        ]
                      }
                    )
                  ],
                  2
                ),
                !_vm.isLogin
                  ? _c(
                      "button",
                      {
                        staticClass: "menu-show",
                        class: { allview: _vm.allmenu },
                        on: { click: _vm.filterMenu }
                      },
                      [
                        _c("i", {
                          class: [
                            _vm.allmenu
                              ? "icon icon-open-arrow"
                              : "icon icon-fold-arrow"
                          ]
                        }),
                        _vm._v(
                          " " +
                            _vm._s(/*메뉴*/ _vm.$t("MMENU-0073")) +
                            " " +
                            _vm._s(
                              !_vm.allmenu
                                ? _vm.$t("MMENU-0074")
                                : _vm.$t("MMENU-0075")
                            ) +
                            " "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.isLogin
                  ? _c(
                      "button",
                      { staticClass: "logout", on: { click: _vm.FN003 } },
                      [
                        _c("i", { staticClass: "icon icon-logout" }),
                        _vm._v(
                          " " +
                            _vm._s(/*로그아웃*/ _vm.$t("MCOM-0000055")) +
                            " "
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _c(
                "div",
                { staticClass: "side-nav-list" },
                [
                  _vm._l(
                    _vm.allmenu ? _vm.getMenuByLogin : _vm.getMenuByLogout,
                    function(m, i) {
                      return [
                        m.isShow &&
                        m.name != "reportAccountMmr" &&
                        m.name != "certificationCenter" &&
                        _vm.currentTab == i
                          ? _c(
                              "div",
                              { key: i },
                              _vm._l(m.children, function(submenu, j) {
                                return _c(
                                  "ul",
                                  { key: "" + m + j + "-1" },
                                  [
                                    submenu.isShow && submenu.children
                                      ? [
                                          _c(
                                            "li",
                                            {
                                              staticClass: "side-nav-list-item"
                                            },
                                            [
                                              _vm.subMenuCheck(submenu.name) &&
                                              submenu.isShow
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "item",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.goPage(
                                                            submenu
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(submenu.title)
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._l(submenu.children, function(
                                                child,
                                                k
                                              ) {
                                                return [
                                                  _vm.isLogin ||
                                                  (!_vm.isLogin &&
                                                    child.name !=
                                                      "vtnOtrbnkTrsaccInfoInptReqStep1")
                                                    ? _c(
                                                        "ul",
                                                        {
                                                          key: j + "-" + k,
                                                          staticClass: "depth-2"
                                                        },
                                                        [
                                                          _vm.subMenu2DepthViewCheck(
                                                            child.name
                                                          ) && child.isShow
                                                            ? _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "item",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.goPage(
                                                                        child
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        child.title
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              })
                                            ],
                                            2
                                          )
                                        ]
                                      : submenu.isShow
                                      ? _c(
                                          "li",
                                          { staticClass: "side-nav-list-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "item",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.goPage(submenu)
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t(submenu.title))
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    }
                  )
                ],
                2
              )
            ])
          ])
        : _vm.popupGbn == 1 || _vm.popupGbn == 2
        ? _c("menu-popup", {
            attrs: { popupGbn: _vm.popupGbn, menuOpen: _vm.menuOpen },
            on: {
              "update:menuOpen": function($event) {
                _vm.menuOpen = $event
              },
              "update:menu-open": function($event) {
                _vm.menuOpen = $event
              }
            }
          })
        : _vm.popupGbn == 3
        ? _c("choose-site-info", {
            attrs: { opened: _vm.openedSetSiteInfoData },
            on: {
              "update:opened": function($event) {
                _vm.openedSetSiteInfoData = $event
              },
              change: function() {
                _vm.menuOpen = false
              }
            }
          })
        : _vm._e(),
      _c("modal-pop", {
        staticClass: "modal",
        attrs: {
          opened: _vm.mmQRPopupOpended,
          modalHeader: true,
          modalFooter: true
        },
        on: {
          "update:opened": function($event) {
            _vm.mmQRPopupOpended = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", { staticClass: "align-center" }, [
                  _c("i", { staticClass: "icon img-mmqr-logo" }),
                  _c("span", { staticClass: "v-hidden" }, [
                    _vm._v(" MyanmarPay "),
                    _c("em", [_vm._v("MMQR")])
                  ])
                ]),
                _c("div", { staticClass: "align-center" }, [
                  _c("h5", { staticStyle: { "line-height": "inherit" } }, [
                    _vm._v(
                      _vm._s(
                        /*Welcome to Myanmar Pay*/ _vm.$t("MPAY-07-01-01-38")
                      )
                    )
                  ]),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        /*Now you can easily make the different digital payments with Myanmar Pay.*/ _vm.$t(
                          "MPAY-07-01-01-39"
                        )
                      )
                    )
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function() {
                        ;(_vm.mmQRPopupOpended = false),
                          (_vm.menuOpen = false),
                          _vm.$router.push({ name: "mmQRAgreeTermsConditions" })
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(/*확인*/ _vm.$t("FIDO-0096")) + " ")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("modal-pop", {
        staticClass: "error",
        attrs: { opened: _vm.mmQRRejectPopupOpended, modalHeader: true },
        on: {
          "update:opened": function($event) {
            _vm.mmQRRejectPopupOpended = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", [
                  _c("div", { staticClass: "error-code" }, [
                    _c("i", { staticClass: "icon icon-error" }),
                    _c("div", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            /*The service is currently not available.*/ _vm.$t(
                              "MPAY-07-01-01-40"
                            )
                          )
                        )
                      ])
                    ])
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        /*Please contact KB Bank Myanmar for assistance.*/ _vm.$t(
                          "MPAY-07-01-01-41"
                        )
                      )
                    )
                  ]),
                  _c("p", [
                    _vm._v(_vm._s(/*전화상담*/ _vm.$t("MCOM-0000031")))
                  ]),
                  _c("div", { staticClass: "btn-area" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn lg inline",
                        on: {
                          click: function($event) {
                            _vm.$goToTel(_vm.$t("지점별콜번호_" + _vm.siteCode))
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "icon icon-call" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("지점별전화번호_" + _vm.siteCode)) +
                            " "
                        )
                      ]
                    )
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function($event) {
                        _vm.mmQRRejectPopupOpended = !_vm.mmQRRejectPopupOpended
                      }
                    }
                  },
                  [_vm._v(_vm._s(/*확인*/ _vm.$t("MOTP-01-01-04-04")))]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("update-popup", { ref: "versionUpdate" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }